import api from "./api";

const CLAVE_TOKEN = "sisdet.token";
const CLAVE_USUARIO = "sisdet.usuario";

export const iniciarSesion = async (usuario, clave) => {
    const respuesta = await api.post("/Token", { user: usuario, password: clave });

    sessionStorage.setItem(CLAVE_TOKEN, respuesta.data.token);
    sessionStorage.setItem(CLAVE_USUARIO, respuesta.data.usuario);

    return respuesta.data.usuario;
}

export const cerrarSesion = () => {
    sessionStorage.removeItem(CLAVE_TOKEN);
    sessionStorage.removeItem(CLAVE_USUARIO);
}

export const obtenerToken = () => sessionStorage.getItem(CLAVE_TOKEN);

export const obtenerUsuario = () => sessionStorage.getItem(CLAVE_USUARIO);

export const haIniciadoSesion = () => obtenerToken() !== null;

export const getUsuarioByCodigo = async (codigo) => {
    const respuesta = await api.get(`/Usuario/GetUsuarioByCodigo?codigo=${codigo}`);

    return respuesta.data.data;
}
